import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import { FaFolder } from "react-icons/fa";

const projectFolders = [
  {
    title: "IMG Ads",
    link: "https://drive.google.com/drive/folders/1s4cht1f_-xRbqQQkdWYX5kFv-KbKAv4v?usp=drive_link",
    disabled: false,
  },
  {
    title: "Localized videos",
    link: "https://drive.google.com/drive/folders/1fUhlIxINCwxe8-TrBZZhp7gMq_0mpJv7?usp=drive_link",
    disabled: false,
  },
  {
    title: "Shortform creatives",
    link: "https://drive.google.com/drive/folders/122Yvw4GdvVYgl5_KKvKGWYdI13wYF6tG?usp=drive_link",
    disabled: false,
  },
  {
    title: "Collaboration",
    link: "#",
    disabled: true,
  },
];

function Projects() {
  return (
    <Container fluid className="project-section bg-accent-black min-h-[100vh] py-24">
      <Particle />
      <Container>
        <h1 className="project-heading text-white">
          My Recent <strong className="text-brand">Works </strong>
        </h1>
        <p className="text-white pb-12">
          Click on the folders below to view my Google Drive portfolios.
        </p>

        <Row className="justify-center gap-y-12 relative z-10">
          {projectFolders.map((folder, index) => (
            <Col md={3} sm={6} xs={12} key={index} className="flex flex-col items-center justify-center">
              <div
                onClick={() => {
                  if (!folder.disabled) {
                    window.open(folder.link, "_blank", "noopener,noreferrer");
                  }
                }}
                className={`flex flex-col items-center group decoration-transparent ${folder.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:-translate-y-2 transition-transform duration-300"}`}
              >
                <div className="text-[#ec4899] mb-4 group-hover:text-white transition-colors duration-300">
                  <FaFolder className="w-32 h-32" />
                </div>
                <h3 className="text-xl font-bold text-white tracking-wide text-center select-none">
                  {folder.title}
                </h3>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </Container>
  );
}

export default Projects;
